module.exports = __webpack_public_path__ + "static/media/flow-monitor-online.706d58dc.svg";